<template>
  <div class="photo-list component" ref="page">
    <UiDataBox :loading="loading" :isEmpty="isEmpty" :error="error">
      <div class="info BOLD" :style="bgImage">
        <div class="content" ref="infoContent">
          <div class="title">{{ item.title }}</div>
          <div class="tags-data-wrapper">
            <div class="date">{{ $moment(item.event_date).format($FORMAT_DATETIME.DATE) }} <span class="divider">|</span></div>
            <TagsView class="tags-tablet" :tagsList="item.tags" labelName="name"></TagsView>
            <div class="views-count" v-if="viewsCount"><span class="divider">|</span><i class="material-icons">remove_red_eye</i>{{ viewsCount }}</div>
          </div>

        </div>
      </div>

      <div class="photos">
        <div class="photo" v-for="photo in getPhotosList" :key="photo.id" :style="`min-height: ${getMinPhotoWidth}px`">
          <router-link :to="{name: 'photo-view', params: {photoId: photo.id}}">
            <ImgLoader :src="photo._thumbnail_mid" animated></ImgLoader>
          </router-link>
        </div>
      </div>
    </UiDataBox>

    <mugen-scroll :handler="loadMorePhotosHandler" :should-handle="!loading"></mugen-scroll>
    <div class="footer">
      <div class="total-photos FONT_TITLE BOLD">{{ getPhotosList.length }} / {{ item.photos.length }}</div>
      <SpinnerWave class="loading-more-photos" v-if="isLoadingMorePhotos"></SpinnerWave>
    </div>

  </div>
</template>

<script>
  import MugenScroll from 'vue-mugen-scroll'
  import slug from 'slug'

  import * as albumsService from '../../services/albums.service'
  import setModelMixin from '../../mixins/setModelMixin'
  import setPageTitle from '../../mixins/setPageTitle'

  import TagsView from '../../components/TagsView.vue'
  import ImgLoader from '../../components/ImgLoader.vue'
  import SpinnerWave from '../../components/SpinnerWave.vue'

  export default {
    name: 'PhotoList',
    mixins: [setModelMixin, setPageTitle],
    props: ['albumId'],
    components: {
      TagsView,
      ImgLoader,
      MugenScroll,
      SpinnerWave
    },
    data () {
      return {
        loading: false,
        error: false,
        infoContentHeight: '',
        photoArrayLimiter: 20,

        slugOptions: {
          lower: true,
          charmap: {
            '$': false // trim $
          }
        },

        item: {
          id: '',
          user_id: '',
          title: '',
          description: '',
          private: '',
          event_location: '',
          event_date: '',
          created_at: '',
          _cover_thumbnail: '',
          _cover_index: '',
          tags: [],
          photos: []
        }
      }
    },

    methods: {
      fetchItem () {
        this.loading = true
        albumsService.getById(this.albumId)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
            this.$store.commit('SET_CURRENT_ALBUM', response.data.photos)
            this.setPageTitle(this.item.title)
          }).catch(error => console.log(error))
          .finally(() => { this.loading = false })
      },
      setInfoContentHeight () {
        this.infoContentHeight = this.$refs.infoContent.offsetHeight
      },
      loadMorePhotosHandler () {
        if (this.photoArrayLimiter > this.item.photos.length) return
        this.photoArrayLimiter += 8
      }
    },

    computed: {
      isEmpty () {
        return !this.item.photos.length
      },
      isLoadingMorePhotos () {
        return this.photoArrayLimiter < this.item.photos.length
      },
      tagsList () {
        return this.item.tags.map(item => item.name)
      },
      bgImage () {
        return `
          ${this.item._cover_index ? `background-image: url(${this.item._cover_index});` : ''}
          height: ${this.infoContentHeight}px;
          background-size: cover;
          background-position: center;`
      },
      getMinPhotoWidth () {
        return this.$refs.page.offsetWidth / 4 / 1.52
      },
      getPhotosList () {
        return this.item.photos.slice(0, this.photoArrayLimiter)
      },
      viewsCount () {
        return this.item.photos
          .map(({ views }) => views)
          .reduce((acc, next) => (acc + next), 0)
      },
      urlHash () {
        return slug(this.item.title, this.slugOptions)
      }
    },

    created () {
      this.fetchItem()
    },

    updated () {
      this.setInfoContentHeight()
      this.$router.replace({
        hash: this.urlHash
      })
    }
  }
</script>

<style lang="scss">
  .photo-list.component {
    padding: 2px;
    .info {
      font-family: $font-title;
      margin-bottom: 2px;
      padding: 50px 50px 45px 50px;
      position: relative;
      overflow: hidden;
      box-sizing: content-box;
      .content {
        width: calc(100% - 100px);
        position: absolute;
        z-index: 2;
        opacity: .5;
        display: flex;
        flex-direction: column;
      }
      &::before{
        display: block;
        content: '';
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAQAAADYv8WvAAAAEklEQVQI12NgaPjPwMDQwNAAAA0DAoC2ub2xAAAAAElFTkSuQmCC);
        background-size: 2px 2px;
      }
      .title {
        text-transform: uppercase;
        font-size: 80px;
        @include media_tablet {
          text-align: center;
        }
        @include media_mobile {
          font-size: 40px;
        }
      }
      .tags-data-wrapper {
        margin-top: -15px;
        display: flex;
        font-size: 20px;

        @include media_tablet {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        @include media_mobile {
          margin-top: -5px;
        }
        .divider {
          @include media_tablet {
            display: none;
          }
        }
        .tags-tablet {
          @include media_tablet {
            justify-content: center;
          }
        }
        .date {
          padding-right: 7px;
          white-space: nowrap;
        }
        .views-count{
          height: 24px;
          display: flex;
          align-items: center;
          padding-bottom: 4px;
          .material-icons{
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
    .photos {
      display: flex;
      flex-wrap: wrap;
      .photo{
        width: 25%;
        border: 1px solid $color-page;
        overflow: hidden;
        &:hover img{
          transform: scale(1.075);
        }
        @include media_tablet {
          width: 33.33%;
        }
        @include media_mobile {
          width: 50%;
        }
        img {
          transition: all .2s;
        }
      }
    }

    .footer {
      display: flex;
      align-items: center;

      .loading-more-photos {
        width: calc(100% - 200px);
      }

      .total-photos {
        min-width: 100px;
        font-size: 16px;
        padding: 25px 0 20px 20px;
        opacity: .5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/album/PhotoList.vue